import React from 'react';
import { Box } from '@mui/material';
import {
  ACTIVE_QR_BORDER_VARIANT,
  getQrBorderSx,
  getQrQuietInnerSx,
  QrBorderVariant,
} from './qr-border-styles';

type QrModuleBorderProps = {
  variant?: QrBorderVariant;
  children: React.ReactNode;
};

export default function QrModuleBorder({
  variant = ACTIVE_QR_BORDER_VARIANT,
  children,
}: QrModuleBorderProps): JSX.Element {
  if (variant === 'quietZoneFramed') {
    return (
      <Box
        data-qr-border={variant}
        sx={getQrBorderSx(variant)}
      >
        <Box data-qr-quiet-inner sx={getQrQuietInnerSx(variant)}>
          {children}
        </Box>
      </Box>
    );
  }
  return (
    <Box
      data-qr-border={variant}
      sx={getQrBorderSx(variant)}
    >
      {children}
    </Box>
  );
}

QrModuleBorder.defaultProps = {
  variant: ACTIVE_QR_BORDER_VARIANT,
};
